/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const CollaboratorCreatePage = lazyLoad(
  () => import('./index'),
  module => module.CollaboratorCreatePage
);
